import { z } from 'zod';
import { KolSearchStatusEnum } from '../enums';
import { recommendationReasonSchema } from './kol.profile';
export const KolSearchStatus = z.enum(KolSearchStatusEnum);
export var KolListTypeEnum;
(function (KolListTypeEnum) {
    KolListTypeEnum["Recommendations"] = "recommendations";
})(KolListTypeEnum || (KolListTypeEnum = {}));
export const KolListType = z.enum(KolListTypeEnum);
export const KolSearchResultModel = z.object({
    id: z.coerce.number(),
    isKol: z.boolean(),
    affiliations: z.array(z.object({
        // id: z.coerce.number(),
        name: z.string(),
        city: z.string().nullish(),
        state: z.string().nullish(),
        street: z.string().nullish(),
        country: z.string().nullish(),
        role: z.string().nullish(),
        zip: z.string().nullish(),
    })),
    name: z.string(),
    firstName: z.string().nullish(),
    lastName: z.string().nullish(),
    email: z.string().nullish(),
    phone: z.string().nullish(),
    qualifications: z.array(z.string()),
    specialties: z.array(z.string()),
    city: z.string().nullish(),
    state: z.string().nullish(),
    streetAddress: z.string().nullish(),
    country: z.string().nullish(),
    zipCode: z.string().nullish(),
    distance: z.number().nullish(),
    locationConfidence: z.number().nullish(),
    locationCoords: z.object({
        latitude: z.number(),
        longitude: z.number(),
    }).nullable().optional(),
    locationName: z.string().nullable().optional(),
    recommendations: z.array(recommendationReasonSchema).nullable().optional(),
});
export const AvailabilityInsightsSchema = z.object({
    totalInteractions: z.number(),
    disclaimer: z.string(),
    insights: z.record(z.string(), z.object({
        count: z.number(),
        pct: z.number(),
        rank: z.enum(['HIGH', 'MEDIUM', 'LOW', 'ZERO']),
    })),
});
